import Lang from './lang';
import SkinStore from './skinStore';
import User from './user';
import Projectdetail from './projectdetail';
import Scheme from './scheme';
import Survey from './survey';
import Topo from './topo';
import Bridge from './bridge';

export default { Lang, SkinStore, User, Projectdetail, Scheme, Survey, Topo, Bridge };
